/**
 * @generated SignedSource<<917820b68288c6cee7edb0ce68294ae0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskSolutionVideoDifferenceCounterLabel_difference$data = {
  readonly isPremium?: {
    readonly after: string | null;
    readonly before: string | null;
  } | null;
  readonly isRecommended?: {
    readonly after: string | null;
    readonly before: string | null;
  } | null;
  readonly taskVideoTitle?: {
    readonly after: string | null;
    readonly before: string | null;
  } | null;
  readonly thumbnailHorizontalUrl?: {
    readonly after: string | null;
    readonly before: string | null;
  } | null;
  readonly thumbnailVerticalUrl?: {
    readonly after: string | null;
    readonly before: string | null;
  } | null;
  readonly " $fragmentType": "TaskSolutionVideoDifferenceCounterLabel_difference";
};
export type TaskSolutionVideoDifferenceCounterLabel_difference$key = {
  readonly " $data"?: TaskSolutionVideoDifferenceCounterLabel_difference$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskSolutionVideoDifferenceCounterLabel_difference">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskSolutionVideoDifferenceCounterLabel_difference",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "isPremium",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "isRecommended",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "taskVideoTitle",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "thumbnailHorizontalUrl",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "thumbnailVerticalUrl",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TaskSolutionVideoDifference",
      "abstractKey": null
    }
  ],
  "type": "Difference",
  "abstractKey": "__isDifference"
};
})();

(node as any).hash = "5c319a226bad997d9d6127f85da878d5";

export default node;
